import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import CustomerModel from '../../../../model/customer.model';
import Helper from '../../../util/helper';
import CustomerService from '../../../../api/customer/customer.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import CustomerSocialMediaModel from '../../../../model/customerSocialMedia.model';
import AddressModel from '../../../../model/address.model';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.scss']
})
export class CustomerFormComponent implements OnInit {
  @Input() customer: CustomerModel;
  public customerDraft: CustomerModel;
  public savingSubject = new BehaviorSubject<boolean>(false);
  public saving$ = this.savingSubject.asObservable();

  constructor(private customerService: CustomerService, public dialogRef: MatDialogRef<CustomerFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CustomerFormDialogModel) {

    if(!this.data.customer) {
      this.customer = {
        name: '',
        additionalAddress: '',
        companyName: '',
        companyDisplayName: '',
        logo: null,
        city: '',
        taxId: '',
        street: '',
        country: '',
        zipCode: '',
        socialMedia: [],
        generalEmail: '',
        generalPhone: '',
        customerType: 'client',
        emailDomain: '',
        accountingType: null,
        createsCredits: false
      } as CustomerModel;
    } else {
      this.customer = this.data.customer;
    }



    this.customerDraft = Object.assign({}, this.customer);

    if(!this.customerDraft.billingAddress) {
      this.customerDraft.billingAddress = {
        firstName: '',
        lastName: '',
        street: '',
        zipCode: '',
        city: '',
        country: ''
      } as AddressModel;
    }
  }

  ngOnInit(): void {
  }

  save() {
    if(this.savingSubject.getValue()) { return; }
    this.savingSubject.next(true);
    /* this prevents circular reference issue */
    let payload = JSON.parse(JSON.stringify(this.customerDraft, Helper.circularReplacer()))
    if(this.customer.id) {
      Object.assign(this.customer, this.customerDraft);
      this.customerService.update(payload).subscribe(result => {
        this.savingSubject.next(false);
        this.dialogRef.close(this.customer);
      }, error => {
        this.savingSubject.next(false);
      });
    } else {
      this.customerService.create(payload).subscribe(result => {
        this.savingSubject.next(false);
        if(result) {
          this.dialogRef.close(result);
        }
      }, error => {
        this.savingSubject.next(false);
      });
    }

  }

  addSocialMedia() {
    this.customerDraft.socialMedia.push({
      name: 'instagram',
      url: ''
    });
  }

  removeSocialMedia(sm: CustomerSocialMediaModel) {
    let index = this.customerDraft.socialMedia.indexOf(sm);
    if(index >= 0) {
      this.customerDraft.socialMedia.splice(index, 1);
    }
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class CustomerFormDialogModel {
  constructor(public customer: CustomerModel) {
  }
}

